import { Client } from "@heroiclabs/nakama-js";

// TODO - add a method to restore a session if tokens are found

async function AddCoins(client, session) {
    try {
        const count = 1000;
        let payload = { "deltaRainbowCoins": count };
        const response = await client.rpc(session, "rpcUpdateWallet", payload);
        console.log(`SUCCESS: ${count} coins have been added to the account.`)
    } catch (e) {
        console.error(e);
        return false;
    }

    PrintCoins(client, session);
    return true;
}

function InitClient() { // :: .. -> Client
    try {
        const useSSL = true; // Enable if server is run with an SSL certificate.
        const client = new Client("oiYG*0PbwlSL!4Fn4NAvu51d!sf48!3sJ7vzZ3WjLnxoEY&6rEsHtfAgVf5Ajguc", "tsedek.faedungeon.com", "443", useSSL);
        return client;
    } catch (e) {
        console.error(e);
    }
}

// Just doing everything in one action for now to keep things simple
async function LoginWithEmail(client, email, password) { // :: .. -> Session
    try {
        // Get the session
        const allowCreate = false;
        const session = await client.authenticateEmail(email, password, allowCreate);

        // Store the session tokens in the browser
        localStorage.setItem("nkmAuthToken", session.token);
        localStorage.setItem("nkmRefreshToken", session.refreshToken);

        return session;
    } catch (e) {
        console.error(e);
    }
}

async function Logout(client, session) { // void
    if (client == null || session == null) {
        return;
    }

    await client.sessionLogout(session);
}

async function PrintCoins(client, session) {
    try {
      let account = await client.getAccount(session);
      let wallet = JSON.parse(account.wallet);

      var keys = wallet.keys;

      if(keys != null)
      {
        keys.forEach(function(currency) {
            console.log("%o: %o", currency, wallet[currency].toString())
        });
      } else {
          console.log("Empty wallet.");
      }

      return account.wallet;
    } catch (e) {
      console.error(e);
    }
}

export {
  AddCoins,
  InitClient,
  LoginWithEmail,
  Logout,
  PrintCoins
}
